import { Backdrop, Box } from '@mui/material';
import React, { useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const renderTime = ({ remainingTime }) => {

  let title = 'Generating Title...';
  if (remainingTime === 0) {
    return <div className="timer">Populated...</div>;
  }

  const showTitle = () => {
    if (remainingTime > 10 && remainingTime < 15) {
      title = 'Generating Synopsis...';
    }
    else if (remainingTime > 5 && remainingTime < 10) {
      title = 'Generating Tags...';
    }
    else if (remainingTime >0  && remainingTime < 5) {
      title = 'Generating IAB Codes...';
    }
    return title;
  }

  return (
    <div className="timer">
      {/* <div className="text">{showTitle()}</div> */}
      <div className="text">{showTitle()}</div>
      <div className="text"></div>
    </div>
  );
};
const CountDownSpinner = () => {
  return (
    <Box sx={{ display: 'flex' }} justifyContent="center" alignItems="center">
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <div className="timer-wrapper">
          <CountdownCircleTimer
            isPlaying
            duration={20}
            colors={['#004777', '#F7B801', '#ff9d00', '#0db080']}
            colorsTime={[20, 15, 5, 0]}
            onComplete={() => ({ shouldRepeat: false, delay: 1 })}
          >
            {renderTime}
          </CountdownCircleTimer>
        </div>
      </Backdrop>
    </Box>
  );
};

export default CountDownSpinner;
